// Keep consistent with enum values: https://github.rbx.com/Roblox/creator-hub-feeds/blob/031169d6001e35028419de7bdd94a886d8da77af/protos/roblox/creatorhubfeeds/creatorhubfeedsservice/v1beta1/creator_hub_feeds_service.proto#L278-L309
import TreeNode from '@modules/ui/shared/interfaces/TreeNode';

export enum Status {
  STATUS_ENUM_INVALID = 0,
  STATUS_ENUM_NOT_STARTED = 1,
  STATUS_ENUM_IN_PROGRESS = 2,
  STATUS_ENUM_COMPLETED = 3,
  STATUS_ENUM_RECOMMENDED = 4,
}

export enum BuildTypeEnum {
  BUILD_TYPE_ENUM_INVALID = 0,
  BUILD_TYPE_ENUM_EXPERIENCE = 1,
  BUILD_TYPE_ENUM_MODELING = 2,
  BUILD_TYPE_ENUM_GENERAL = 3,
}

export enum DevExperienceEnum {
  DEV_EXPERIENCE_ENUM_INVALID = 0,
  DEV_EXPERIENCE_ENUM_BEGINNER = 1,
  DEV_EXPERIENCE_ENUM_INTERMEDIATE = 2,
  DEV_EXPERIENCE_ENUM_ADVANCED = 3,
}

export enum ModelingExperienceEnum {
  MODELING_EXPERIENCE_ENUM_INVALID = 0,
  MODELING_EXPERIENCE_ENUM_BEGINNER = 1,
  MODELING_EXPERIENCE_ENUM_INTERMEDIATE = 2,
  MODELING_EXPERIENCE_ENUM_ADVANCED = 3,
}

export enum CourseIdEnum {
  EXPERIENCE_BEGINNER = 'experience-beginner',
  EXPERIENCE_INTERMEDIATE = 'experience-intermediate',
  EXPERIENCE_ADVANCED = 'experience-advanced',
  AVATAR_BEGINNER = 'avatar-beginner',
  AVATAR_INTERMEDIATE = 'avatar-intermediate',
  AVATAR_ADVANCED = 'avatar-advanced',
}

export enum SurveyStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 1,
  COMPLETED = 2,
}

export type Course = {
  courseId: string;
  milestones: Milestone[];
  isCompleted: Status;
};

export type Lesson = {
  title: string;
  path: string;
  duration: number;
  durationUnit: string;
};

export type Milestone = {
  number: number;
  title: string;
  duration: number;
  durationUnit: string;
  lessons: Lesson[];
};

export interface SurveyAnswer {
  id?: number;
  buildType: BuildTypeEnum;
  devExperience: DevExperienceEnum;
  modelingExperience: ModelingExperienceEnum;
  createdTime?: Date;
  updatedTime?: Date;
}

export interface SurveyOption {
  value: BuildTypeEnum | ModelingExperienceEnum | DevExperienceEnum;
  titleKey: string;
}

export interface StepContent {
  titleKey: string;
  descriptionKey: string;
  stepNumber?: number;
  options?: SurveyOption[];
  selectedOption?: BuildTypeEnum | ModelingExperienceEnum | DevExperienceEnum;
  showOptions?: boolean;
  recommendedCourse?: string;
}

export interface CourseData {
  milestones: number;
  completedMilestones: number;
  status: Status;
  nextLesson?: string;
  nextLessonPath?: string;
}

export interface CourseRowCardProps {
  courseId: string;
  titleKey: string;
  status: Status;
  milestones: number;
  completedMilestones: number;
  descriptionKey: string;
  imageSrc?: string;
  imageAlt?: string;
  onResetProgress?: (courseId: string) => void;
  nextLesson?: string;
  nextLessonPath?: string;
  className?: string;
  style?: React.CSSProperties;
  error?: boolean;
}

export type MilestoneNode = TreeNode & {
  milestoneIndex: number;
  heading?: string;
};
